import React, {FC} from 'react';

import {DropdownProps} from '../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {CommentModel} from '../../../models/api/commentModel';
import {NewPanelId} from '../../../store/panels/panelStateBase';
import {FloatingCommentDropdownContainer} from './floatingCommentDropdownContainer';

interface FloatingActivityDropdownProps extends DropdownProps {
  panelId: NewPanelId;
  comment?: CommentModel;
}

export const FloatingActivityDropdown: FC<FloatingActivityDropdownProps> = (props) => {
  const {comment} = props;

  // We actually only support comments, but we want to deal with missing comments here.
  if (!comment) {
    return null;
  }

  return (
    <FloatingCommentDropdownContainer
      panelId={props.panelId}
      comment={comment}
      anchor={props.anchor}
      placement={props.placement}
      onRequestClose={props.onRequestClose}
    />
  );
};
